import { all, put, select, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions/rootActions';
import * as actionTypes from '../actions/actionTypes';
import { browserHistory } from '../../index';
import ApiService from '../../services/apiService';
import i18n from '../../react-i18next';
import { THEMES_TYPE } from '../../helpers/constants';
import { SUPPORTED_LANGUAGES } from '../../locales';

function* getSurveySaga() {
  try {
    const token = yield select((state) => state.auth.token);
    if (token) {
      const response = yield ApiService.get('survey', {
        headers: { Authorization: token },
      }).catch((error) => console.log(error));
      if (response) {
        const survey = { ...response.data };
        yield put(actions.setThemeData(survey.theme_type));

        if (survey.theme_type === THEMES_TYPE.myCustomerVoice) {
          i18n.changeLanguage(SUPPORTED_LANGUAGES.ENGLISH);
        }

        survey.questions = survey.questions.map((question) => {
          return {
            question_id: question.id,
            name: question.name,
            comment: '',
            ranking: '',
            photos: [],
          };
        });
        survey.survey_id = null;
        yield put(actions.saveSurvey(survey));
        yield put(actions.setIsLoadingLogin(false));
      }
    } else {
      browserHistory.push('/error');
    }
  } catch (error) {
    console.log('Error: ', error);
    browserHistory.push('/error');
  }
}

export default function* surveySaga() {
  yield all([takeLatest(actionTypes.GET_SURVEY, getSurveySaga)]);
}
